import { render } from "./PhotoGrid.vue?vue&type=template&id=d132e7e2&scoped=true"
import script from "./PhotoGrid.vue?vue&type=script&lang=js"
export * from "./PhotoGrid.vue?vue&type=script&lang=js"

import "./PhotoGrid.vue?vue&type=style&index=0&id=d132e7e2&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d132e7e2"]])

export default __exports__